import { Grid } from "@mui/material";
import GuidePdfViewer from "../Common/Guide/GuidePdfViewer";
import {
  GridContainerStyle,
  PageContainer,
} from "../Common/Container/ContainerStyled";
import { useDeviceType } from "../../hooks/useDeviceType";

function VehicleGuide() {
  const deviceType = useDeviceType();
  return (
    <PageContainer>
      <Grid sx={GridContainerStyle(deviceType)}>
        <GuidePdfViewer filePath="/guide/vehicleGuide.pdf" />
      </Grid>
    </PageContainer>
  );
}

export default VehicleGuide;
